import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import BlobRight from "../assets/Blob-right.svg";
import BlobLeft from "../assets/Blob-left.svg";
import "../App.css";

const Home = ({ screenInfo }) => {
  const { isDesktopModeOnMobile, width } = screenInfo;
  const [blobWidth, setBlobWidth] = useState(80);


  useEffect(() => {
    const updateBlobSize = () => {
      const calculatedWidth = 80 + window.innerWidth * 0.002;
      const newWidth = Math.min(calculatedWidth, 100);
      setBlobWidth(newWidth);
    };

    window.addEventListener("resize", updateBlobSize);
    updateBlobSize();

    return () => window.removeEventListener("resize", updateBlobSize);
  }, []);
  const textVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.5, duration: 0.8, ease: "easeOut" },
    }),
    hover: { scale: 1.1, transition: { duration: 0.3 } },
  };
  return (
    <div className={`${ isDesktopModeOnMobile && width > 768    ? "":"lg:min-h-screen max-sm:min-h-screen "} flex flex-col w-full `}>
      <div className={`${ isDesktopModeOnMobile && width > 768   ? "":"lg:min-h-screen max-sm:min-h-screen "} flex flex-row justify-between relative w-full  `}>
        {/* Left Blob Container */}
        <motion.div
          className="flex justify-start items-start w-[50%] sm:w-[40%] md:w-[40%] lg:w-[30%] xl:w-[30%]"
          animate={{ y: [0, -20, 0] }}
          transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
        >
          <motion.img
            src={BlobLeft}
            alt="Left Blob"
            className={`${isDesktopModeOnMobile ? "":"w-full h-[50vh] sm:h-[70vh] md:h-[80vh] lg:h-screen xl:h-[110vh]"}
              
        `}
            animate={{ width: `${blobWidth}%` }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
          />
        </motion.div>

        {/* Text Section */}
        <div className="flex flex-col justify-center items-center absolute  z-40 space-y-4  pl-[20%] sm:pl-0  w-full h-full   poppins-bold max-xxs:text-4xl text-5xl sm:text-5xl sm:text-center md:text-6xl lg:text-7xl xl:text-8xl text-white  overflow-hidden">
          {["Code", "Transform", "Grow"].map((word, index) => (
            <motion.p
              key={word}
              className="w-full origin-center"
              variants={textVariants}
              initial="hidden"
              animate="visible"
              whileHover="hover"
              custom={index}
            >
              {word}
            </motion.p>
          ))}
        </div>

        {/* Right Blob Container */}
        <motion.div
          className="flex justify-end items-end lg:items-start xl:items-start z-20  mt-[5rem] w-[50%] sm:w-[40%] md:w-[40%] lg:w-[30%] xl:w-[30%] "
          animate={{ y: [0, 20, 0] }}
          transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
        >
          <motion.img
            src={BlobRight}
            alt="Right Blob"
            className={`${isDesktopModeOnMobile ? "":"w-full h-[50vh] sm:h-[70vh] md:h-[80vh] lg:h-screen xl:h-[110vh]"}
              
        `}
            animate={{ width: `${blobWidth}%` }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
          />
        </motion.div>
      </div>
    </div>
  );
};

export default Home;
